<!--  -->
<template>
  <div class="total">
    <img style="width: 100%" src="@/../static/img/productsTitle.jpg" alt="" />
    <div style="position: relative">
      <img style="width: 100%" src="@/../static/img/productsTwo.jpg" alt="" />
      <div class="title">
        <div
          style="position: relative"
          @click="SelectService(index)"
          v-for="(item, index) in title"
          :key="item.url"
        >
          <div
            :class="
              index == StyleTransformation ? 'title-content1' : 'title-content'
            "
          >
            <div
              style="
                width: 2.7rem;
                height: 1.2rem;
                display: flex;
                align-items: center;
              "
            >
              <img class="title-img" :src="item.url" alt="" />
            </div>

            <div style="padding-top: 0.1rem">{{ item.text }}</div>
          </div>
          <div v-show="index == StyleTransformation" class="arrow"></div>
        </div>
      </div>
    </div>
    <div style="position: relative">
      <img
        style="width: 100%"
        :src="
          '@/../static/img/productsView' + (StyleTransformation + 1) + '.jpg'
        "
        alt=""
      />
      <vue-flux
        class="img-content"
        :options="vfOptions"
        :images="vfImages"
        :transitions="vfTransitions"
        ref="slider"
      >
        <template v-slot:caption>
          <flux-caption />
        </template>
      </vue-flux>
    </div>
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";
export default {
  name: "home",
  components: {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
  },
  data() {
    return {
      vfOptions: {
        autoplay: true,
      },
      vfImages: [
        "@/../static/img/hospital/1.png",
        "@/../static/img/hospital/2.png",
        "@/../static/img/hospital/3.png",
      ],
      //   vfImages1: [
      //     "@/../static/img/region/1.png",
      //     "@/../static/img/region/2.png",
      //     "@/../static/img/region/3.png",
      //   ],
      //   vfImages2: [
      //     "@/../static/img/MedicalAssociation/1.png",
      //     "@/../static/img/MedicalAssociation/2.png",
      //     "@/../static/img/MedicalAssociation/3.png",
      //   ],
      vfTransitions: ["zip"],

      title: [
        {
          url: "@/../static/img/productsTitle1.png",
          text: "医院数字影像服务",
        },
        {
          url: "@/../static/img/productsTitle2.png",
          text: "区域数字影像云服务",
        },
        {
          url: "@/../static/img/productsTitle3.png",
          text: "医联（共）体数字影像云服务",
        },
      ],
      StyleTransformation: 0,
    };
  },

  computed: {},

  mounted() {},

  methods: {
    SelectService(index) {
      switch (index) {
        case 0:
          this.vfImages = [
            "@/../static/img/hospital/1.png",
            "@/../static/img/hospital/2.png",
            "@/../static/img/hospital/3.png",
          ];
          break;
        case 1:
          this.vfImages = [
            "@/../static/img/region/1.png",
            "@/../static/img/region/2.png",
            "@/../static/img/region/3.png",
          ];
          break;
        case 2:
          this.vfImages = [
            "@/../static/img/MedicalAssociation/1.png",
            "@/../static/img/MedicalAssociation/2.png",
            "@/../static/img/MedicalAssociation/3.png",
          ];
          break;
        default:
          break;
      }
      this.StyleTransformation = index;
    },
  },
};
</script>
<style lang='less' scoped>
.total {
  width: 100%;
  height: 100%;
}
.title {
  width: 100%;
  height: 2.5rem;
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .title-content {
    background-color: #d1e4ff;
    width: 2.7rem;
    height: 2rem;
    text-align: center;
    margin: 0 30px;
    color: #12366c;
    font-size: 0.16rem;
    padding-top: 0.2rem;
    border-radius: 15px;
    cursor: pointer;
  }
  .title-content1 {
    background-color: #196eee;
    width: 2.7rem;
    height: 2rem;
    text-align: center;
    margin: 0 30px;
    color: #fff;
    font-size: 0.16rem;
    padding-top: 0.2rem;
    border-radius: 15px;
  }
  .title-img {
    width: 1.8rem;
    margin: auto;
  }
  .arrow {
    width: 0;
    height: 0;
    border: 16px solid;
    position: absolute;
    bottom: -0.25rem;
    left: 1.55rem;
    border-color: transparent transparent #196eee;
  }
}
.img-content {
  width: 9rem;
  height: 5.4rem;
  position: absolute;
  right: 2rem;
  top: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/products.vue